export default {
  '--uploader-action-background': '#303030',
  '--uploader-action-icon-color': '#fff',
  '--uploader-file-name-background': '#303030',
  '--uploader-file-name-color': '#aaa',
  '--uploader-file-cover-background': '#303030'
};